import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { useMemo } from 'react';
import { classNames } from '../../helpers/classnames.js';

var List = function (_a) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? 'ul' : _b, props = __rest(_a, ["className", "type"]);
    var classes = useMemo(function () { return classNames('dsb_list', className); }, [className]);
    return type === 'ul' ? (React__default.createElement("ul", __assign({ "data-testid": "List" }, props, { className: classes }))) : (React__default.createElement("ol", __assign({ "data-testid": "List" }, props, { className: classes })));
};

export { List };
